import { isEuEnv, getUserLang } from '@mb/lib/i18n';
import {
  isHomePage,
  isPartnersPage,
  isBannersPage,
  isCuratedCollectionPage,
} from '../utils/helpers/isPage';

export const environments = {
  stage: 'stage',
  uat: 'uat',
  prod: 'prod',
  dev4: 'dev4',
  sandbox: 'sandbox',
  localhost: 'localhost',
  discover: 'discover',
  prodEu: 'prodEu',
};

export const LOCAL_STORAGE_KEY = 'mage-cache-storage';
export const MAX_PROJECTS = 5;
export const SIZE_OF_THUMBNAIL_IMAGE = 25;
export const ALTERNATE_SIZE_OF_THUMBNAIL_IMAGE = 48;
export const MAXIMUM_NUMBER_OF_DISPLAYED_THUMBNAILS = 2;
export const BASE_CATEGORY_SET = [
  'Materials>Tile',
  'Materials>Paints',
  'Materials>Textiles',
  'Materials>Wallcovering',
  'Materials>Flooring',
  'Materials>Surfaces>Laminate',
  'Materials>Paneling',
  'Materials>Textiles>Acoustic',
  'Materials>Leather',
];
export const TRACKING_LOCAL_STORAGE_KEY = 'mb-hp-tracking-data';
export const SPLITIO_EVENT_NAMES = {
  search: 'mb_frontend_homepage_search',
  orders: 'mb_frontend_homepage_go_to_orders',
  projects: 'mb_frontend_homepage_go_to_projects',
  collections: 'mb_frontend_homepage_go_to_collections',
  boards: 'mb_frontend_homepage_go_to_boards',
};

function getEnv() {
  const hostname = window.location.hostname;

  if (hostname.includes('uat')) {
    return environments.uat;
  } else if (hostname.includes('materialbank.eu')) {
    return environments.prodEu;
  } else if (hostname.includes('stage')) {
    return environments.stage;
  } else if (hostname.includes('dev4')) {
    return environments.dev4;
  } else if (hostname.includes('sandbox')) {
    return environments.sandbox;
  } else if (hostname.includes('discover')) {
    return environments.discover;
  } else if (hostname === 'localhost') {
    return environments.localhost;
  } else {
    return environments.prod;
  }
}

export const env = getEnv();

export const isStageEnv = env === environments.stage;
export const isUAT = env === environments.uat;
export const isDev4 = env === environments.dev4;
export const isProdEnv = env === environments.prod;
export const isSandboxEnv = env === environments.sandbox;
export const isLocalhost = env === environments.localhost;
export const isDiscoverEnv = env === environments.discover;
export const isProdEuEnv = env === environments.prodEu;

const apiURLv1 = 'rest/V1';
const apiURLv2 = '/rest/V2/sdg-api';
const userLang = getUserLang();
const langPrefix = isEuEnv ? `/${userLang}` : '';

const apiFavoriteUrl = `${apiURLv2}/favorite/mine`;
const designsRootUrl = `https://cci6wn10kb.execute-api.us-west-2.amazonaws.com/${
  isProdEnv || isProdEuEnv ? 'production' : 'dev'
}`;
const itemsPerPage = isPartnersPage()
  ? 5
  : isHomePage() && !isBannersPage()
  ? 10
  : isCuratedCollectionPage()
  ? 100
  : 65;

const configGlobal = typeof SEARCH_CONFIG !== 'undefined' ? SEARCH_CONFIG : {};
export const testCustomerId = configGlobal?.product?.testCustomerId;
const apiURL =
  configGlobal?.product?.siteUrl?.replace(/\/$/, '') ||
  'https://search.materialbank.com/v2';

const v3_URL = apiURL?.replace('v2', 'v3');
const config = {
  searchSpring: {
    searchURL: apiURL,
    suggestionsURL: 'https://3yga07.a.searchspring.io/api/suggest/query',
    autocompleteURL: 'https://autocomplete2.searchspring.net',
    byKey: `${apiURL}/bykey`,
    compare: `${apiURL}/compare`,
    siteId: configGlobal?.product?.siteId || 'materialbank_product',
    getFirstChild: '/product/request/firstchildid',
    children: `${apiURL}/collection/children`,
    recommendStripA1: `${v3_URL}/recommend`,
  },

  endpoints: {
    addRestrictedItem: `${apiURLv1}/restricted-items-track`,
    getServices: '/mit_diverzify/diverzify',
    getCustomer: '/sdg_customer/account/ajaxinfo',
    postCurrentUserProject: '/sdg_project/project/projectssetlist',
    addToBag: `${langPrefix}/sdg_cart/lineitem/addmultiple`,
    cart: `${apiURLv1}/carts/mine`,
    getConfigurableProduct: `${apiURLv1}/sdg-api/getproduct2`,
    getProjectTypes: `${apiURLv1}/sdg-api/projects/type/list`,
    projects: `${apiURLv2}/projects/mine/`,
    launches: '/launches_frontend/campaign/get',
    analytics: `${apiURL}/analytics/event`,
    adhoc: `${apiURL}/analytics/event/adhoc`,
    encryptMessage: `${designsRootUrl}/encrypt-message`,
    exportToCSV: `${apiURLv2}/products/export-specs`,
    notify: `${apiURLv1}/notification-center/mine/wait-list/`,
    exportToPDF: (productIds: string[], zipFileName: string) =>
      `/board/board/download/product_ids/${productIds.join()}/board_name/${zipFileName}`,
  },
  search: {
    resultsPerPage: itemsPerPage,
  },
  filters: {
    defaultLimit: 5,
    step: 20,
  },
  maxSelectNumber: itemsPerPage,
  favoritesToggle: `${apiFavoriteUrl}/items/toggle`,
  favorites: `${apiFavoriteUrl}/items`,
  favoriteBoard: apiFavoriteUrl,
};

export { config };
